import { Component, OnInit, Input } from '@angular/core';
import { ResumenImputacionesService } from '@components/resumen-imputaciones/resumen-imputaciones.service';
import { StorageService, ObservatoryService } from '@services/services.module';
import { ResumenImputacion } from '@components/resumen-imputaciones/resumen-imputaciones.model';

@Component({
  selector: 'app-resumen-imputaciones',
  templateUrl: './resumen-imputaciones.component.html',
  styleUrls: ['./resumen-imputaciones.component.scss']
})
export class ResumenImputacionesComponent implements OnInit {
  public formatDayFirst: any;
  public formatDayLast: any;
  public initDate: string;
  public endDate: string;
  public employeeId: string;
  public amountHoursS1: number;
  public amountHoursS2: number;
  public amountHoursS3: number;
  public totalPending: number;
  public imputacionData: ResumenImputacion = new ResumenImputacion;
  public userData: any;
  public firstDay: string;
  public lastDay: string;
  public dateMonthFinal: string;
  public dateDayFinal: string;
  public monthString: string;
  public yearNumber: number;

  calendarYear: any;
  @Input() empleado;
  constructor(
    private _resumenImputacionService: ResumenImputacionesService,
    private storage: StorageService,
    private observatory: ObservatoryService
  ) {}

  ngOnInit(): void {
    // inicializar variables a 0 para evitar errores en la carga de html
    this.amountHoursS1 = 0;
    this.amountHoursS2 = 0;
    this.amountHoursS3 = 0;
    this.userData = this.storage.get('userDataStorage');
    this.employeeId = this.userData.employeeNumber;
    this.observatory.getData('CalendarYearDate').subscribe(val => {
      this.initDate = val.initDate;
      this.endDate = val.endDate;
      this.employeeId = val.employeeId;
      this.obtenerResumen();
    });
  }

  obtenerResumen() {
     this._resumenImputacionService
       .getImputacionesData(this.initDate, this.endDate, this.employeeId)
       .subscribe(val => {
        this.amountHoursS1 = 0;
        this.amountHoursS2 = 0;
        this.amountHoursS3 = 0;
        if (this.empleado === 0) {
          val.activityTypeS1 = [];
          val.activityTypeS2 = [];
          val.activityTypeS3 = [];
          val.totalHoursImputation = '0';
        }
        this.imputacionData = val;
        // this.observatory.setData('horasGrafico', this.imputacionData);
        const totalHours = parseFloat(this.imputacionData.totalHours) ;
        this.imputacionData.totalPending = (totalHours - this.amountHoursS1).toString();

        if (this.imputacionData.activityTypeS1.length > 0 ) {
          this.imputacionData.activityTypeS1.forEach(s => {
            this.amountHoursS1 += Number(s.hours);
          });
        }
        if (this.imputacionData.activityTypeS2.length > 0) {
          this.imputacionData.activityTypeS2.forEach(s => {
            this.amountHoursS2 += Number(s.hours);
          });
        }
        if (this.imputacionData.activityTypeS3.length > 0) {
          this.imputacionData.activityTypeS3.forEach(s => {
            this.amountHoursS3 += Number(s.hours);
          });
        }
       });
  }
}
